import { render } from "./MySentIOURequests.vue?vue&type=template&id=64858c92&scoped=true"
import script from "./MySentIOURequests.vue?vue&type=script&lang=js"
export * from "./MySentIOURequests.vue?vue&type=script&lang=js"

import "./MySentIOURequests.vue?vue&type=style&index=0&id=64858c92&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/jahajibd.com/ia.jahajibd.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64858c92"]])

export default __exports__